import JournalEventBasedComponent from 'parog-web/components/forc/abstract/journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import JournalEventRetrievalStrategies from 'parog-web/components/forc/utils/journal-event-retrieval-strategies';
import CrisisPlanDeclaredJournalEvent from 'parog-web/models/crisis-plan-declared-journal-event';
export default class CrisisPlanFormComponent extends JournalEventBasedComponent {
  static override forcDisplayName = 'Définition du plan de crise';
  static override fullComponentId = 'crisis-plan/edition-form';
  static override journalEventClass = CrisisPlanDeclaredJournalEvent;

  override journalEventProperties = [
    'occurredAt',
    'crisisPlanDate',
    'mentalWarnings',
    'mentalActionsToTake',
    'mentalContacts',
    'depressiveWarnings',
    'depressiveActionsToTake',
    'depressiveContacts'
  ];
  override retrieveJournalEvent =
    JournalEventRetrievalStrategies.sourceOrLastJournalEvent;

  override computePayload() {
    const payload = super.computePayload();
    payload.occurredAt = new Date();
    return payload;
  }

  <template>
    <Provider @forcComponent={{this}}>
      <:content as |Form|>
        <div class='field'>
          <Form.Date
            @labelName='Date de définition du plan de crise'
            @propertyName='crisisPlanDate'
          />
        </div>
        <div class='ui header'>
          Épisode maniaque
        </div>
        <div class='field'>
          <Form.TextArea
            @labelName='Signes annonciateurs'
            @propertyName='mentalWarnings'
            @rows={{3}}
          />
        </div>
        <div class='field'>
          <Form.TextArea
            @labelName='Actions à entreprendre'
            @propertyName='mentalActionsToTake'
            @rows={{3}}
          />
        </div>
        <div class='field'>
          <Form.TextArea
            @labelName='Personnes à contacter'
            @propertyName='mentalContacts'
            @rows={{3}}
          />
        </div>
        <div class='ui header'>
          Épisode dépressif
        </div>
        <div class='field'>
          <Form.TextArea
            @labelName='Signes annonciateurs'
            @propertyName='depressiveWarnings'
            @rows={{3}}
          />
        </div>
        <div class='field'>
          <Form.TextArea
            @labelName='Actions à entreprendre'
            @propertyName='depressiveActionsToTake'
            @rows={{3}}
          />
        </div>
        <div class='field'>
          <Form.TextArea
            @labelName='Personnes à contacter'
            @propertyName='depressiveContacts'
            @rows={{3}}
          />
        </div>
      </:content>
    </Provider>
  </template>
}
